import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { Radio } from "antd";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { Form, Input, message, Checkbox } from "antd";
import commonRules from "components/Pages/User/common/rules";
// import Dynamic, { } from "components/App/Dynamic/index-new";

import DynamicOld, { DynamicProps, type ExposeDynamicProps } from "components/App/Dynamic";
import Geetest from "components/Geetest";
import { FaItemProps, FaSceneDictEnum } from "store/user";
import SafeVerify, { FaCheckProps } from "components/App/SafeVerify/index";
import { axiosThrottle } from "utils/method";
import XtSvg from "components/Xt/Svg";
import { waitRes } from "utils/axios";
import { getSecurityLevel, get_faResult, get_getFaCheckItem, get_resetKycInfo, resetFaItem, resetFaItemAuth } from "api/uaapi/user";
import AppCountryList from "components/App/Country";
import { getOrigin } from "utils/method";
import useNextTick from "hooks/useNextTick";
import { CheckboxOptionType, CheckboxValueType } from "antd/lib/checkbox/Group";
import { getToken } from "utils/common/token";
import Vector from "assets/images/account/Vector.png";
import NoEmail from "components/Xt/NoEmail";
import AuthUpload from "../Levels/_CMPT/Upload";
import { checkIsLegalUrl } from "utils/validation";

import localeMap from "./map";

interface MobileProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const { useForm } = Form;

enum StepComponentProps {
  FirstStep = 1,
  SecondStep = 2,
  ThirdStep = 3,
  FourthStep = 4,
  FifthStep = 5,
  SixthStep = 6,
}

const getObjStr = (str, userInfo) => {
  let obj = {};
  if (userInfo) {
    obj = {
      EMAIL: 31,
      MOBILE: 32,
      GA: 33,
      "MOBILE,EMAIL": 34,
      "GA,EMAIL": 35,
      "GA,MOBILE": 36,
      "GA,MOBILE,EMAIL": 37,
    };
  } else {
    obj = {
      EMAIL: 41,
      MOBILE: 42,
      GA: 43,
      "MOBILE,EMAIL": 44,
      "GA,EMAIL": 45,
      "GA,MOBILE": 46,
      "GA,MOBILE,EMAIL": 47,
    };
  }
  return obj[str];
};

const Mobile: React.FC<MobileProps> = ({ className }) => {
  const t = useTranslation();
  const { userInfo } = store.user;
  const router = useRouter();
  const nextTick = useNextTick();
  const { isDark } = store.app;
  const [formIns] = useForm();
  const [faCheckId, setFaCheckId] = useState(router.query.faCheckId);
  const [stepComponent, setStepComponent] = useState<StepComponentProps>(StepComponentProps.FirstStep);

  const [optionsData, setOptionsData] = useState<CheckboxOptionType[]>([]);
  const [checkData, setCheckData] = useState<CheckboxValueType[]>([]);

  const [faBizType, setFaBizType] = useState(0);
  const [faCheckData, setFaCheckData] = useState<FaCheckProps>({
    faCheckId: "",
    isAnswer: 0,
    email: "",
    countryCode: "",
    mobile: "",
    faItems: [],
  });

  const getTitle = useMemo(() => {
    const obj = {
      1: t("newAccount.resetVerification"),
      2: t("newAccount.safeCode"),
      3: t("newAccount.resetVerification"),
      4: t("newAccount.resetVerification"),
      5: t("newAccount.resetVerification"),
      6: t("newAccount.resetVerification"),
    };
    return obj[stepComponent];
  }, [stepComponent]);

  useEffect(() => {
    if (router.query.faCheckId) {
      setFaCheckId(router.query.faCheckId);
    }
  }, [router.query]);

  useEffect(() => {
    handleGetSecurityLevel();
  }, [faCheckId]);

  const handleGetSecurityLevel = async () => {
    if (!faCheckId) return;
    const { data, err } = await waitRes(getSecurityLevel, {
      noHandle401: true,
      errorPop: true,
      params: {
        faCheckId,
      },
    });
    if (err) return;

    const { isAuthGoogle, isAuthMobile, isAuthEmail, mobile, email } = data;
    const optionsArr: CheckboxOptionType[] = [];
    if (isAuthGoogle == 1) {
      optionsArr.push({ label: t("newAccount.resetGa"), value: "GA" });
    }
    if (isAuthMobile == 1) {
      optionsArr.push({
        label: t("newAccount.resetMobile", {
          v1: mobile,
        }),
        value: "MOBILE",
      });
    }
    if (isAuthEmail == 1) {
      optionsArr.push({
        label: t("newAccount.resetEmail", {
          v2: email,
        }),
        value: "EMAIL",
      });
    }
    setOptionsData(optionsArr);
  };

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setCheckData(checkedValues);
  };

  const handleResetItem = async () => {
    console.log(11111);
    const str = checkData.join(",");
    const dynamicObj = {
      EMAIL: "USER_2015",
      MOBILE: "USER_2016",
      GA: "USER_2017",
      "MOBILE,EMAIL": "USER_2018",
      "GA,EMAIL": "USER_2020",
      "GA,MOBILE": "USER_2019",
      "GA,MOBILE,EMAIL": "USER_2021",
    };
    setDynamicCodeType(dynamicObj[str]);
    setFaBizType(() => getObjStr(str, userInfo));
  };

  useEffect(() => {
    if (!!faBizType) {
      getFaCheckItem();
    }
  }, [faBizType]);

  useEffect(() => {
    if (faCheckData.faItems.length) {
      handleChangeStep(true, StepComponentProps.SecondStep);
    } else {
      handleGetFaResult();
    }
  }, [faCheckData]);

  const getFaCheckItem = async () => {
    const { data, err } = await waitRes(get_getFaCheckItem, {
      noHandle401: true,
      errorPop: true,
      params: { faBizType, faCheckId },
    });
    if (err) return;
    setFaCheckData(data);
  };

  const handleChangeStep = (type, step = StepComponentProps.FirstStep) => {
    if (type) {
      setStepComponent(step);
    } else {
      setStepComponent(StepComponentProps.FirstStep);
      setCheckData([]);
      formIns.setFieldsValue({ ...initForm });
      setFaBizType(0);
      if (router.query.faId) {
        setFaCheckId(router.query.faId);
      }
    }
  };
  // 返回上一页
  const goBack = () => {
    handleChangeStep(false);
    setFormData({ ...initForm });
  };
  const handleGetFaResult = async () => {
    if (!faCheckData.faCheckId) return;

    const { data, err } = await waitRes(get_faResult, {
      errorPop: true,
      params: {
        faBizType: faBizType,
        faCheckId: faCheckData.faCheckId,
        emailCode: undefined,
        googleCode: undefined,
        mobileCode: undefined,
      },
    });
    if (!err) {
      updateResultStep(data, true);
    }
  };

  const handleChangeFaCheckData = (prop, val) => {
    const newFaCheckData = faCheckData;
    newFaCheckData[prop] = val;
    setFaCheckData(newFaCheckData);
  };

  const updateResultStep = (data, boll = false) => {
    boll && handleChangeFaCheckData("faResultId", data.faResultId);
    if ([33, 43].includes(Number(faBizType))) {
      //只重置ga不需要进入第三步骤
      if (faCheckData.isAnswer == 1) {
        handleChangeStep(true, StepComponentProps.FourthStep);
      } else {
        handleChangeStep(true, StepComponentProps.FifthStep);
      }
    } else {
      handleChangeStep(true, StepComponentProps.ThirdStep);
    }
  };

  // 第二步
  const handleSuccessFn = (res) => {
    updateResultStep(res, true);
  };

  // 第三步
  const geetestRef = React.useRef<any>();
  const [showModal, setShowModal] = useState(false);
  const [noEmailVisible, setNoEmailVisible] = useState(false);
  const [noEmailClickNumber, setNoEmailClickNumber] = useState(0);
  const appCodeDynamicRef = useRef({} as ExposeDynamicProps);
  const appEmailCodeDynamic = useRef({} as ExposeDynamicProps);
  const [refType, setRefType] = useState(0);
  const [mobileMsgType, setMobileMsgType] = useState(0);
  const [puzzleValidate, setPuzzleValidate] = useState("");
  const [dynamicCodeType, setDynamicCodeType] = useState("");
  const initForm = {
    email: "",
    emailCode: "",
    mobile: "",
    mobileCode: "",
    countryId: 0,
    countryCode: "",
  };
  type FormDataType = typeof initForm & ObjAny;
  const [formData, setFormData] = useState({ ...initForm });
  const valuesChange = (changedValues: FormDataType, allValues: FormDataType) => {
    const data = { ...formData, ...changedValues };
    setFormData(data);
  };

  const disabledForm = useMemo(() => {
    const arr: string[] = [];
    if (checkData.includes("MOBILE")) {
      arr.push("mobile", "mobileCode");
    }
    if (checkData.includes("EMAIL")) {
      arr.push("email", "emailCode");
    }
    return arr.some((k1) => formData[k1] == "");
  }, [formData, checkData]);

  const manageCheckTextArr = useMemo(() => {
    const list: string[] = [];
    checkData.forEach((item) => {
      switch (item) {
        case "GA":
          list.push(t("newAccount.ga"));
          break;
        case "MOBILE":
          list.push(t("newAccount.mobile"));
          break;
        case "EMAIL":
          list.push(t("newAccount.email"));
          break;
      }
    });
    return list.join("+");
  }, [checkData]);

  const noEmailChange = () => {
    if (noEmailClickNumber) {
      setNoEmailVisible(true);
    }
    setNoEmailClickNumber(1);
  };

  const handleGeetestSuccess = async (puzzleValidateString) => {
    setPuzzleValidate(puzzleValidateString);
    if (refType == 1) {
      appCodeDynamicRef.current.handleClick(true, puzzleValidateString);
    }
    if (refType == 2) {
      appEmailCodeDynamic.current.handleClick(true, puzzleValidateString);
    }
  };

  const submitThirdForm = axiosThrottle(async (unlock) => {
    await formIns.validateFields();
    const { data, err } = await waitRes(resetFaItemAuth, {
      errorPop: true,
      isResFull: true,
      data: {
        ...formData,
        faBizType,
        faCheckId: faCheckData.faCheckId,
        faResultId: faCheckData.faResultId,
      },
    });
    unlock();
    if (err) return;
    handleChangeFaCheckData("faResetAuthId", data.data.faResetAuthId);
    //判断是否需要答题
    if (faCheckData.isAnswer == 1) {
      handleChangeStep(true, StepComponentProps.FourthStep);
    } else {
      handleChangeStep(true, StepComponentProps.FifthStep);
    }
  });

  // 第四步
  const [timeLeft, setTimeLeft] = useState(5 * 60); // 初始倒计时时间为3分钟，以秒为单位
  const [answerOptions, setAnswerOptions] = useState([
    {
      index: 1,
      tit: `${t("newAccount.recentlyRecharge")}(${t("newAccount.singleOption")})`,
      list: [
        {
          label: "BTC",
          value: 1,
        },
        {
          label: "ETH",
          value: 2,
        },
        {
          label: "USDT",
          value: 3,
        },
        {
          label: "EOS",
          value: 4,
        },
        {
          label: "XRP",
          value: 5,
        },
        {
          label: "ADA",
          value: 6,
        },
        {
          label: "XWC",
          value: 7,
        },
        {
          label: t("newAccount.allFalse"),
          value: 8,
        },
      ],
      value: 0,
    },
    {
      index: 2,
      tit: `${t("newAccount.holdAmount")}(${t("newAccount.singleOption")})`,
      list: [
        {
          label: "≤" + `10${t("newAccount.indivual")}`,
          value: 1,
        },
        {
          label: `≤50${t("newAccount.indivual")}`,
          value: 2,
        },
        {
          label: `≤100${t("newAccount.indivual")}`,
          value: 3,
        },
        {
          label: `≤200${t("newAccount.indivual")}`,
          value: 4,
        },
        {
          label: `≤300${t("newAccount.indivual")}`,
          value: 5,
        },
        {
          label: t("newAccount.allFalse"),
          value: 8,
        },
      ],
      value: 0,
    },
    {
      index: 3,
      tit: `${t("newAccount.holdCoin")}(${t("newAccount.singleOption")})`,
      list: [
        {
          label: "BTC",
          value: 1,
        },
        {
          label: "ETH",
          value: 2,
        },
        {
          label: "USDT",
          value: 3,
        },
        {
          label: "EOS",
          value: 4,
        },
        {
          label: "XRP",
          value: 5,
        },
        {
          label: "ADA",
          value: 6,
        },
        {
          label: "XWC",
          value: 7,
        },
        {
          label: t("newAccount.allFalse"),
          value: 8,
        },
      ],
      value: 0,
    },
  ]);
  useEffect(() => {
    let timer;
    if (stepComponent == StepComponentProps.FourthStep) {
      // 定义一个定时器来更新倒计时
      timer = setInterval(() => {
        if (timeLeft > 0) {
          setTimeLeft(timeLeft - 1);
        } else {
          window.location.reload();
        }
      }, 1000);
    }

    // 在组件卸载时清除定时器
    return () => {
      clearInterval(timer);
    };
  }, [timeLeft, stepComponent]);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const [answerStep, setAnswerStep] = useState(1);
  const [radioVal, setRadioVal] = useState("");
  const [faAnswerDTOS, setFaAnswerDTOS] = useState([]);
  let flag = false;

  useEffect(() => {
    if (!radioVal || flag) return;
    const index = answerStep - 1;
    const newOptionsData = [...answerOptions];
    answerOptions[index].value = Number(radioVal);
    setAnswerOptions(newOptionsData);
    setRadioVal("");
  }, [radioVal]);

  useEffect(() => {
    if (stepComponent == StepComponentProps.FourthStep) {
      answerOptions.sort(() => (Math.random() > 0.5 ? -1 : 1));
    }
  }, [stepComponent]);

  const radioOptions = useMemo(() => {
    return answerOptions[answerStep - 1].list;
  }, [answerStep]);
  const answerTitle = useMemo(() => answerOptions.find((item) => item.index == answerStep)?.tit, [answerStep, answerOptions]);
  const onChangeRadio = ({ target: { value } }) => {
    setRadioVal(value);
  };
  const radioValue = useMemo(() => {
    return answerOptions[answerStep - 1].value;
  }, [answerStep, answerOptions]);

  const handlePrevBtn = () => {
    if (answerStep > 1) {
      flag = true;
      setAnswerStep(answerStep - 1);
    }
  };

  const handleNextBtn = () => {
    if (answerStep == 3) {
      handleSubmitAnswer();
      handleChangeStep(true, StepComponentProps.FifthStep);
      return;
    } else {
      flag = false;
      setAnswerStep(answerStep + 1);
    }
  };

  const disabledFourthForm = useMemo(() => {
    return !answerOptions[answerStep - 1].value;
  }, [answerOptions, answerStep]);

  const handleSubmitAnswer = () => {
    const faAnswerDTOS: any = [];
    answerOptions.forEach((item, index) => {
      faAnswerDTOS.push({
        finalNum: item.index,
        option: item.value,
        webNum: index + 1,
      });
    });
    setFaAnswerDTOS(faAnswerDTOS);
  };

  // 第五步
  const [kycInfo, setKycInfo] = useState({
    countryName: "",
    realName: "",
    cardType: 0,
    cardId: "",
  });

  const uploadUrl = useMemo(() => {
    return "/uaapi/user/user/fa/item/upload?faCheckId=" + faCheckId;
  }, [faCheckId]);
  useEffect(() => {
    if (stepComponent == StepComponentProps.FifthStep) {
      handleGetResetKycInfo();
    }
  }, [stepComponent]);

  const handleGetResetKycInfo = async () => {
    try {
      const res = await get_resetKycInfo({
        params: {
          faResultId: faCheckData.faResultId,
        },
      });
      setKycInfo(res || {});
    } catch (error) {
      console.log(error);
    }
  };

  const [authImg, setAuthImg] = useState("");

  const submitFiveForm = async () => {
    try {
      await resetFaItem({
        data: {
          authImg: authImg,
          faAnswerDTOS: faAnswerDTOS,
          faBizType: faBizType,
          faResultId: faCheckData.faResultId,
          faResetAuthId: faCheckData.faResetAuthId,
        },
      });
      handleChangeStep(true, StepComponentProps.SixthStep);
    } catch (error) {
      console.log(error);
    }
  };

  // 第六步
  const getOriginUrlWithLocale = (path = "", api = "www") => {
    const slash = !path || path[0] === "/" ? "" : "/";
    const origin = getOrigin(api) + "/" + router.locale + slash + path;
    return origin;
  };
  const handleGoBack = () => {
    if (checkIsLegalUrl(router.query.backUrl as string, getOrigin("", "no"))) {
      if (typeof window !== "undefined") {
        window.location = router.query.backUrl as any as Location;
      }
    } else {
      location.href = getOriginUrlWithLocale();
    }
  };

  return (
    <div className={cx(styles.mobile, className, isDark ? styles["mobile_dark"] : styles["mobile_light"])}>
      <div className={styles["tan"]}>
        <XtSvg src={require("@/assets/icon-svg/app/tan.svg")} />
        <div className={styles["text_tan"]}>
          {stepComponent > 2 ? t("newAccount.resetNewTip") : ""} {t("google.safeFund")}
        </div>
      </div>
      <div className={styles["content"]}>
        <div className={styles["right_fa"]}>
          <div className={styles["right_1"]}>
            {stepComponent !== StepComponentProps.FirstStep && (
              <div onClick={goBack}>
                <div className={styles["back"]}>
                  <div className={styles["back_logo"]}>
                    <img
                      style={{ marginRight: "11px", width: "10px", height: "18px" }}
                      src={require(`@/assets/images/back${isDark ? "_dark" : ""}.png`).default}
                      alt=""
                    />
                  </div>
                  <div className={styles["back_text"]}>{t("app.back")}</div>
                </div>
              </div>
            )}
            <div className={styles["title"]}>{getTitle}</div>

            <div className={styles["tip"]}>
              <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
              {stepComponent === StepComponentProps.FirstStep && (
                <>
                  <div className={styles["label"]}>{t("newAccount.resetVerificationTips")}</div>

                  <div className={styles["first-box"]}>
                    <Checkbox.Group options={optionsData} onChange={onChange} value={checkData} />
                  </div>

                  <div className={cx(styles["base-btn"], !checkData.length && styles["disabledBtn"])} onClick={handleResetItem}>
                    {t("newAccount.resetTrue")}
                  </div>
                </>
              )}

              {/* 第二步 */}
              {stepComponent === StepComponentProps.SecondStep && (
                <>
                  <div className={styles["labelTitle"]}>{t("newAccount.safeCodeTips")}</div>

                  <SafeVerify
                    faCheckData={faCheckData}
                    showLink={false}
                    faBizType={faBizType}
                    dynamicCodeType={dynamicCodeType}
                    handleSuccessFn={handleSuccessFn}
                  />
                </>
              )}

              {/* 第三步 */}
              {stepComponent === StepComponentProps.ThirdStep && (
                <>
                  <p className={styles["tips"]}>{t("newAccount.thirdStepTips")}</p>
                  <div className={styles["top-info"]}>
                    <img src={Vector} alt="" />
                    <span>
                      {t("newAccount.reset")} {manageCheckTextArr}
                    </span>
                  </div>

                  <Form name="safeVerifyForm" initialValues={formData} form={formIns} onValuesChange={valuesChange} layout="vertical">
                    {checkData.indexOf("MOBILE") > -1 && (
                      <>
                        <div className={styles["labelTitle"]}>{t("mobile.newVerify")}</div>
                        <Form.Item className={styles["n-country-box"]} label={t("mobile.new")}>
                          <div className={styles["mobile_country"]}>
                            <AppCountryList
                              selectItem={(obj) => {
                                setFormData({ ...formData, countryCode: obj?.code || "", countryId: obj.id });
                              }}
                              countryQuery="MOBILE"
                              showType="Small"
                            />
                          </div>
                          <Form.Item noStyle name="mobile" rules={commonRules.mobile}>
                            <Input className={styles["common_form_input"]} autoComplete="new-text" />
                          </Form.Item>
                        </Form.Item>
                        <Form.Item label={t("mobile.newVerify")} name="mobileCode" rules={commonRules.mobileCode}>
                          <Input
                            className={styles["common_form_input"]}
                            allowClear
                            autoComplete="off"
                            maxLength={6}
                            suffix={
                              <div>
                                <DynamicOld
                                  ref={appCodeDynamicRef}
                                  isNew={true}
                                  mobileNew={formData.mobile}
                                  FaValidTypeDict={"MOBILE"}
                                  puzzleValidateString={puzzleValidate}
                                  msgType={mobileMsgType}
                                  faCheckId={faCheckData.faCheckId}
                                  codeType={dynamicCodeType}
                                  disableClick={true}
                                  countryCode={formData.countryCode}
                                  onClick={() => {
                                    setMobileMsgType(0);
                                    nextTick(() => {
                                      setRefType(1);
                                      (geetestRef?.current as any).verify();
                                    });
                                  }}
                                />
                              </div>
                            }
                          />
                        </Form.Item>
                        {/* 语音验证码功能已注释 */}
                        {/* <div className={cx(styles["voice"], styles["mt12"])}>
                          <span onClick={() => { ... }}>{t("2fa.voiceCode")}</span>
                        </div> */}
                      </>
                    )}
                    {checkData.indexOf("EMAIL") > -1 && (
                      <>
                        <div className={styles["labelTitle"]}>{t("account.newEmailVerify")}</div>
                        <Form.Item label={t("email.new")} name="email" rules={commonRules.email}>
                          <Input className={styles["common_form_input"]} autoComplete="new-text" />
                        </Form.Item>
                        <Form.Item name="emailCode" label={t("account.newEmailVerifyCode")} rules={commonRules.emailCode}>
                          <Input
                            maxLength={6}
                            allowClear
                            className={styles["common_form_input"]}
                            autoComplete="new-text"
                            suffix={
                              <div className={styles["forget_password"]}>
                                <DynamicOld
                                  ref={appEmailCodeDynamic}
                                  isNew={true}
                                  FaValidTypeDict={"EMAIL"}
                                  emailNew={formData.email}
                                  faCheckId={faCheckData.faCheckId}
                                  puzzleValidateString={puzzleValidate}
                                  msgType={2}
                                  codeType={dynamicCodeType}
                                  noEmailChange={noEmailChange}
                                  onClick={() => {
                                    nextTick(() => {
                                      setRefType(2);
                                      (geetestRef?.current as any).verify();
                                    });
                                  }}
                                />
                              </div>
                            }
                          />
                        </Form.Item>
                        {noEmailVisible && (
                          <div className={cx(styles["text2"], styles["no_email"])} onClick={() => setShowModal(true)}>
                            {t("google.noEmail")}
                          </div>
                        )}
                      </>
                    )}
                    <div className={cx(styles["base-btn"], disabledForm && styles["disabledBtn"])} onClick={submitThirdForm}>
                      {t("account.confirm")}
                    </div>
                  </Form>
                </>
              )}

              {/* 第四步 */}
              {stepComponent === StepComponentProps.FourthStep && (
                <>
                  <p className={styles["tips"]}>{t("newAccount.thirdStepTips")}</p>
                  <div className={styles["top-info"]}>
                    <img src={Vector} alt="" />
                    <span>
                      {t("newAccount.reset")} {manageCheckTextArr}
                    </span>
                  </div>
                  <div className={styles["answer-time"]}>
                    <div>{t("newAccount.answerTips")}</div>
                    <div>
                      {t("newAccount.answerTime")}: {formatTime(timeLeft)}
                    </div>
                  </div>
                  <div className={styles.mt20}>
                    {answerStep}. {answerTitle}
                  </div>
                  <div className={styles["answer-box"]}>
                    <Radio.Group options={radioOptions} onChange={(e: any) => onChangeRadio(e)} value={radioValue} />
                  </div>

                  <div className={styles["btn-wrapper"]}>
                    {answerStep > 1 && (
                      <div className={styles["base-btn"]} onClick={handlePrevBtn}>
                        {t("newAccount.prevAnswer")}
                      </div>
                    )}

                    <div
                      className={cx(styles["base-btn"], disabledFourthForm && styles["disabledBtn"])}
                      style={{ width: answerStep == 1 ? "100%" : "" }}
                      onClick={handleNextBtn}
                    >
                      {[1, 2].includes(answerStep) ? t("newAccount.nextAnswer") : t("newAccount.submitAnswer")}
                    </div>
                  </div>
                </>
              )}

              {/* 第五步 */}
              {stepComponent == StepComponentProps.FifthStep && (
                <>
                  <p className={styles["tips"]}>{t("newAccount.thirdStepTips")}</p>
                  <div className={styles["top-info"]}>
                    <img src={Vector} alt="" />
                    <span>
                      {t("newAccount.reset")} {manageCheckTextArr}
                    </span>
                  </div>
                  {kycInfo.realName && (
                    <>
                      <div className={styles["labelTitle"]}>{t("newAccount.kyc")}</div>
                      <div className={styles["content-kyc"]}>
                        <div className={styles["content-kyc-item"]}>
                          <div>{t("newAccount.userArea")}</div>
                          <div>{kycInfo.countryName}</div>
                        </div>
                        <div className={styles["content-kyc-item"]}>
                          <div>{t("newAccount.userCard")}</div>
                          <div>
                            {kycInfo.cardType == 1 && t("ent.idCard")}
                            {kycInfo.cardType == 2 && t("ent.passport")}
                            {kycInfo.cardType == 3 && t("ent.driverCard")}
                            {kycInfo.cardType == 4 && t("ent.others")}
                          </div>
                        </div>
                        <div className={styles["content-kyc-item"]}>
                          <div>{t("newAccount.userCardNumber")}</div>
                          <div>{kycInfo.cardId}</div>
                        </div>
                        <div className={styles["content-kyc-item"]}>
                          <div>{t("newAccount.userName")}</div>
                          <div>{kycInfo.realName}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className={styles["labelTitle"]}>{t("newAccount.kycPic")}</div>
                  <div className={styles["content-upload"]}>
                    <div className={styles["content-upload-tips"]}>
                      <div>{t("newAccount.kycPicTips1")}</div>
                      {kycInfo.realName ? (
                        <div className="kyc-tips" dangerouslySetInnerHTML={{ __html: t("newAccount.kycPicTipsXT") }} />
                      ) : (
                        <div className={styles["kyc-tips"]} dangerouslySetInnerHTML={{ __html: t("newAccount.inLeftHand") }} />
                      )}
                    </div>
                  </div>
                  <div className={cx(styles["form_bg"], styles["form_Idcard_third"])}>
                    <AuthUpload
                      limit={5120}
                      params="authImg"
                      action={uploadUrl}
                      attr={{ imgType: "kyc" }}
                      onChangeImg={(key, val) => {
                        setAuthImg(val);
                      }}
                    />
                  </div>
                  <div className={cx(styles["base-btn"], !authImg && styles["disabledBtn"])} onClick={submitFiveForm}>
                    {t("account.confirm")}
                  </div>
                </>
              )}

              {/* 第六步 */}
              {stepComponent == StepComponentProps.SixthStep && (
                <>
                  <p className={styles["tips"]}>{t("newAccount.thirdStepTips")}</p>
                  <div className={styles["top-info"]}>
                    <img src={Vector} alt="" />
                    <span>
                      {t("newAccount.reset")} {manageCheckTextArr}
                    </span>
                  </div>
                  <div className={styles["top-icon"]}></div>
                  <div className={styles["desc"]}>{t("newAccount.reviewTips")}</div>
                  <div className={styles["base-btn"]} onClick={handleGoBack}>
                    {t("app.back")}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <NoEmail open={showModal} changeOpen={() => setShowModal(false)} email={faCheckData.email} />
    </div>
  );
};
export default observer(Mobile);
